import { LocalStorage } from './local.storage';

export class SessionStorage extends LocalStorage {
    protected storage = window.sessionStorage;
}
